module.exports = __webpack_public_path__ + "images/22978769ba42befc74c4dcde54b879c4.png";